import routes from '@/../config/routes';
import { useLocation } from '@umijs/max';
import { useMemo } from 'react';

export const getConfigRoute = (pathname: string, route: any): any => {
  if (route.path === pathname) {
    return route;
  }
  if (route.routes) {
    for (const r of route.routes) {
      const res = getConfigRoute(pathname, r);
      if (res) {
        return res;
      }
    }
  }
  return undefined;
};

export const useRoutes = () => {
  return useMemo(() => routes, []);
};

export const useCurrentRoute = (pathname?: string) => {
  const location = useLocation();
  const appRoutes = useRoutes();
  const currentPathname = pathname || location.pathname;

  return useMemo(() => {
    return getConfigRoute(currentPathname, { routes: appRoutes });
  }, [currentPathname, appRoutes]);
};
